import { Component } from '@angular/core';

@Component({
    selector: 'app-health',
    templateUrl: './health.component.html',
    styleUrl: './health.component.css',
    standalone: false
})
export class HealthComponent {
}
